import { render, staticRenderFns } from "./TradeDownload.vue?vue&type=template&id=aa94fb78&scoped=true&"
import script from "./TradeDownload.vue?vue&type=script&lang=js&"
export * from "./TradeDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa94fb78",
  null
  
)

export default component.exports